/* eslint-disable no-nested-ternary */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
import React, { useState } from 'react';
import ThreeDotsLoader from '../../Components/LoadingDots';
import { PriceHandler } from '../../redux/helper/CamelCase';

function UpdateTransactionModal({
    updateTransactionModal, setUpdateTransactionModal, selectedTransaction, setSelectedTransaction, updateTransactionInformation, setUpdateTransactionInformation, setInvoicesearchValue, invoicesearchValue, handleUpdate, selectedItem, threeDotsLoader,
    setThreeDotsLoader,
}) {
    const toggleState = {
        invoice: false,
        payment_type: false,

    };
    const [toggle, settoggle] = useState(toggleState);

    const handleDropdownStatus = () => {
        settoggle(toggleState);
    };

    const handleToggle = (key) => {
        handleDropdownStatus();
        const val = key === 'start_date' ? 'end_date' : 'start_date';
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
            [val]: false,
        }));
    };

    const invoiceSearch = (value) => {
        if (invoicesearchValue === '') {
            return value;
        } if ((value.INVOICE_NO).toLowerCase().includes(invoicesearchValue.toLowerCase())) {
            return value;
        }
    };

    const InputChange = (value) => {
        setUpdateTransactionInformation((prevState) => ({
            ...prevState,
            amount: value,
        }));
    };

    return (
        <div className={`modal fade fixed top-0 left-0 ${updateTransactionModal ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="updateTransaction" tabIndex="-1" aria-labelledby="updateInvoiceModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none min-w-[449px] sm:max-w-[449px] mx-auto px-2.5" style={{ margin: 'auto' }}>
                <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current px-4 py-[18px]">
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[10px] rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full invoice" id="exampleModalScrollableLabel1">
                            Update Transaction
                        </h5>
                        <button
                            type="button"
                            className="absolute top-4 right-6"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setUpdateTransactionModal(false)}
                        >
                            <img src="/images/Icon-ionic-ios-close.svg" alt="icon" />
                        </button>
                    </div>
                    <div className="modal-body relative sm:px-[30px] px-3 sm:pt-[24px] sm:pb-7 pb-[24px] text-center">
                        <form className="w-full">
                            <div className="flex">
                                <div>
                                    <p className="text-xs3 font-semibold text-[#808285]">Remaining Amount</p>
                                    <p className="text-sm58 font-semibold text-[#15090E] pt-[3px]">{PriceHandler(selectedItem.due_amount)}</p>
                                </div>
                                <div className="ml-[24px]">
                                    <p className="text-xs3 font-semibold text-[#808285]">Payment Ref. Number</p>
                                    <p className="text-sm58 font-semibold text-[#15090E] pt-[3px]">{selectedItem.payment_id}</p>
                                </div>
                            </div>
                            <div className="w-full mt-[27px]">
                                <div className="dropdown relative">
                                    <button
                                        type="button"
                                        id="special14"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        className="dropdown-to flex justify-between items-center h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5 err-MsgInvoiceBorder"
                                        onClick={() => {
                                            handleToggle('invoice');
                                            // setsubmitSelected(false);
                                        }}
                                    >
                                        <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3 px-1 bg-[#FFFFFF]">
                                            Invoice
                                            <span className="text-[#ED1C24]">*</span>
                                        </p>
                                        {updateTransactionInformation.invoice === '' ? <span className="text-[#AAA6AF] text-base font-normal text-left">Choose the Invoice</span> : <span className="text-[#090406] text-base font-normal text-left">{updateTransactionInformation.invoice}</span>}
                                        <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5" />
                                    </button>
                                    <ul className={`dropdown-menu w-full ${toggle.invoice ? '' : 'hidden'} absolute top-[48px] right-0 bg-[#FFFFFF] rounded-[10px] shadow-s2 z-[9999] pb-2.5 px-[15px] pb-3 max-h-[140px] overflow-auto custom-scrollbar`} aria-labelledby="special14">
                                        <li
                                            className="w-full bg-[#ffffff] pt-3.5 sticky top-0"
                                        >
                                            <div className="relative">
                                                <label htmlFor="" />
                                                <input
                                                    type="text"
                                                    className="border border-[#A5A5A5] rounded-lg bg-[#ffffff] w-full h-[38px] placeholder:text-xs21 placeholder:text-[#A5A5A5] placeholder:font-normal text-base font-normal text-[#090406] pl-[9px] pr-[30px] outline-none"
                                                    placeholder="Search"
                                                    value={invoicesearchValue}
                                                    onChange={(e) => {
                                                        setInvoicesearchValue(e.target.value);
                                                    }}
                                                    autoComplete="off"
                                                />
                                                <img src="/images/search.svg" alt="icon" className="absolute top-3.5 right-2.5" />
                                            </div>
                                        </li>
                                        {selectedTransaction.length > 0 && selectedTransaction.filter((value) => invoiceSearch(value)).map((ele) => (
                                            <li
                                                className="w-full bg-[#ffffff] pt-2"
                                                onClick={() => {
                                                    setUpdateTransactionInformation((prevState) => ({
                                                        ...prevState,
                                                        invoice: ele.TRX_NUMBER,
                                                        amount: Math.min(ele.DUE_INVOICE_AMT || 99999999999999, selectedItem.due_amount, ele.INVOICE_VALUE),
                                                    }));
                                                    settoggle((prevState) => ({
                                                        ...prevState,
                                                        invoice: false,
                                                    }));
                                                }}
                                            >
                                                <a href="#" className="w-full dropdown-item inline-block text-base font-normal text-[#090406] text-left">
                                                    {ele.TRX_NUMBER}
                                                    {'  '}
                                                    {ele.DUE_INVOICE_AMT === null
                                                        ? (
                                                            (`(${PriceHandler(ele.INVOICE_VALUE)})`)
                                                        ) : (
                                                            `(${PriceHandler(ele.DUE_INVOICE_AMT)})`
                                                        )}
                                                </a>
                                            </li>
                                        )) }
                                    </ul>
                                </div>
                            </div>
                            <p className="text-xs13 font-normal text-[#ED1C24] text-left hidden err-MsgInvoice pt-0.5">Select Invoice</p>
                            <p className="text-xs13 font-normal text-[#ED1C24] text-left hidden err-MsgInvoice1 pt-0.5">Text is too long .Please limit it to 500 characters.</p>
                            <div className="relative mt-[27px]">
                                <label htmlFor="amount" className="text-xs2 font-semibold text-[#808285] absolute top-[-11px] left-3 px-1 bg-[#ffffff]">
                                    Amount
                                    <span className="text-[#ED1C24]">*</span>
                                </label>
                                <input
                                    name="enterMoremessage"
                                    id="amount"
                                    className="w-full px-[13px] py-[11px] border border-[#B1B4B7] rounded-lg text-base font-normal text-[#090406] outline-none err-MsgInvoiceBorder"
                                    onChange={(e) => {
                                        if (selectedItem.due_amount >= Number(e.target.value)) {
                                            InputChange(e.target.value);
                                        } else {
                                            InputChange('');
                                        }
                                    }}
                                    value={updateTransactionInformation.amount === '' ? updateTransactionInformation.amount_due < selectedItem.due_amount ? updateTransactionInformation.amount_due : selectedItem.due_amount : updateTransactionInformation.amount}
                                />
                            </div>
                            <p className="text-xs13 font-normal text-[#ED1C24] text-left hidden err-MsgInvoice pt-0.5">Amount is required</p>
                            <p className="text-xs13 font-normal text-[#ED1C24] text-left hidden err-MsgInvoice1 pt-0.5">Please enter amount less than remaining amount</p>
                        </form>
                        <div className="flex w-full mt-6 pb-1">
                            <div className="flex justify-center w-full">
                                <button
                                    type="submit"
                                    className="w-[284px] sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold text-[#FFFFFF] invoice-proceded"
                                    onClick={() => handleUpdate()}
                                    disabled={threeDotsLoader}
                                >
                                    {threeDotsLoader ? <div className="ml-[125px]"><ThreeDotsLoader /></div> : 'Proceed'}
                                </button>
                                <p className="pt-1 text-sm58 font-normal text-[#090406] invoice-content hidden">Updated by John Doe on 13/05/2022 12:45pm</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UpdateTransactionModal;
